import { Checkbox } from "@/v2/components/ui/checkbox";

export const ACTIONS = ["FACE_OFF", "GOAL", "HIT", "PASS", "PENALTY", "SAVE", "SHIFT", "SHOT"];

/** Display label only — the underlying action code (used for aria-label and
 *  the payload) stays the raw ACTIONS value. */
function actionLabel(action: string): string {
  if (action === "FACE_OFF") return "Face-off";
  return action.charAt(0) + action.slice(1).toLowerCase();
}

type ActionsColumnProps = {
  selectedEvent: string[];
  setSelectedEvent: (events: string[]) => void;
  isSelectAllEvent: boolean;
  setIsSelectAllEvent: (v: boolean) => void;
};

export function ActionsColumn({
  selectedEvent,
  setSelectedEvent,
  isSelectAllEvent,
  setIsSelectAllEvent,
}: ActionsColumnProps) {
  function toggleSelectAll(checked: boolean) {
    if (checked) {
      setSelectedEvent([]);
      setIsSelectAllEvent(true);
    } else {
      setIsSelectAllEvent(false);
    }
  }

  function toggleAction(action: string, checked: boolean) {
    if (checked) {
      setSelectedEvent([...selectedEvent, action]);
    } else {
      setSelectedEvent(selectedEvent.filter((a) => a !== action));
    }
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-card flex flex-col min-h-0">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
        <div className="font-bold text-slate-900 text-base">4 · Actions</div>
        <span className="text-sm font-bold px-3 py-1 rounded-full bg-action-light text-action">
          {isSelectAllEvent && selectedEvent.length === 0 ? "All" : `${selectedEvent.length} selected`}
        </span>
      </div>
      <div className="flex items-center justify-between px-4 pt-3">
        <span className="text-sm font-bold text-slate-500" style={{ letterSpacing: "0.04em" }}>
          EVENT TYPES
        </span>
        <label className="flex items-center gap-2 text-sm font-semibold text-action cursor-pointer whitespace-nowrap">
          Select all
          <Checkbox
            aria-label="Select All"
            checked={selectedEvent.length === 0 && isSelectAllEvent}
            onCheckedChange={(next) => toggleSelectAll(next === true)}
            className="size-4"
          />
        </label>
      </div>
      <div className="p-2 overflow-y-auto max-h-80">
        {ACTIONS.map((action, i) => {
          const checked = selectedEvent.includes(action);
          return (
            <label
              key={action}
              className={`flex items-center gap-4 px-3 py-2 rounded-xl cursor-pointer ${
                checked ? "bg-action-light" : "hover:bg-accent"
              } ${i > 0 ? "border-t border-slate-100" : ""}`}
            >
              <Checkbox
                aria-label={action}
                checked={checked}
                onCheckedChange={(next) => toggleAction(action, next === true)}
                className="size-5 rounded-md shrink-0"
              />
              <span className="text-base font-semibold text-slate-800">{actionLabel(action)}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
